<template>
  <div class="kycFile">
    <div class="go-back" v-if="stepNum <= 3" @click="goBack">
      <div class="back-icon"></div>
      <div class="back-word">{{$t('common.back')}}</div>
    </div>
    <div class="kyc-content" id="kycContent" v-loading="loading">
      <basicsInfo
        ref="basicsInfo"
        @toNext="nextBasicsInfo"
        v-if="stepNum == 1"
      ></basicsInfo>
      <identityInfo
        ref="identityInfo"
        @toNext="nextIdentityInfo"
        @toBefore="beforeIdentityInfo"
        v-if="stepNum == 2"
      ></identityInfo>
      <identitySecInfo
        ref="identitySecInfo"
        @toNext="nextIdentitySecInfo"
        @toBefore="beforeIdentitySecInfo"
        v-if="stepNum == 3"
      ></identitySecInfo>
      <openAccountForm
        ref="openAccountForm"
        @toNext="nextOpenAccountForm"
        v-if="stepNum == 4"
      ></openAccountForm>
      <subSuccess v-if="stepNum == 5"></subSuccess>
    </div>
    <div class="fixed-common" v-if="stepNum <= 4">
      <div class="bottom-page">
        <lls-button
          type="primary"
          plain
          :disabled="false"
          v-if="stepNum == 2 || stepNum == 3 || stepNum == 4"
          @click="before()"
          style="margin-right:10px;"
          v-html="$t('enterprise.previous')"
          ></lls-button
        >
        <lls-button
          type="primary"
          :disabled="false"
          @click="next()"
          v-if="stepNum == 1 || stepNum == 2 || stepNum == 3"
          v-html="$t('enterprise.next')"
          ></lls-button
        >
        <lls-button
          type="primary"
          :disabled="false"
          @click="submit()"
          v-if="stepNum == 4"
          v-html="$t('enterprise.submit')"
          ></lls-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import basicsInfo from "./kycCommon/basicsInfo.vue";
import identityInfo from "./kycCommon/identityInfo.vue";
import identitySecInfo from "./kycCommon/identitySecInfo.vue";
import transacPassword from "./kycCommon/transacPassword.vue";
import openAccountForm from "./kycCommon/openAccountForm.vue";
import subSuccess from "./kycCommon/subSuccess.vue";
export default {
  name: "kycFile",
  components: {
    basicsInfo,
    identityInfo,
    identitySecInfo,
    openAccountForm,
    subSuccess,
    transacPassword,
  },
  data() {
    return {
      stepNum: 1,
      loading: false,
      enterpriseId: sessionStorage.getItem("enterpriseId"),
    };
  },
  methods: {
    before() {
      if(this.stepNum == 2){
        this.$refs.identityInfo.beforeSon();
      }else if(this.stepNum == 3){
        this.$refs.identitySecInfo.beforeSon();
      }else{
        this.stepNum--;
        $("#kycContent").animate({ scrollTop: 0 });
      }
    },
    next() {
      if (this.stepNum == 1) {
        this.$refs.basicsInfo.nextSon();
      } else if (this.stepNum == 2) {
        this.$refs.identityInfo.nextSon();
      } else if (this.stepNum == 3) {
        this.$refs.identitySecInfo.nextSon();
      }
    },
    nextBasicsInfo() {
      this.stepNum++;
      $("#kycContent").animate({ scrollTop: 0 });
    },
    nextIdentityInfo() {
      this.stepNum++;
      $("#kycContent").animate({ scrollTop: 0 });      
    },
    nextIdentitySecInfo(){
      this.stepNum++;
    },
    beforeIdentityInfo(){
      this.stepNum--;
      $("#kycContent").animate({ scrollTop: 0 });
    },
    beforeIdentitySecInfo(){
      this.stepNum--;
      $("#kycContent").animate({ scrollTop: 0 });
    },
    nextOpenAccountForm() {
      this.stepNum++;
    },
    nextTransacPassword() {
      this.stepNum++;
    },
    submit() {
      this.$refs.openAccountForm.nextSon();
    },
    goBack() {
      this.$router.push({path: '/main-productCenter'});
    },
  },
};
</script>
<style lang="scss" scoped>
.kycFile {
  width: 100%;
  height: 100%;
  background-color: #fff;
  border-radius: 8px;
  padding: 20px 30px 0;
  position: relative;
  .go-back {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    cursor: pointer;
    margin-bottom: 20px;
    .back-icon {
      width: 6px;
      height: 10px;
      background: url("~@/static/kjaccSonImg/backFill.svg") center center
        no-repeat;
    }
    .back-word {
      font-size: 14px;
      line-height: 16px;
      color: #89929e;
      margin-left: 8px;
    }
  }
  .kyc-content {
    height: calc(100% - 104px);
    overflow-y: auto;
  }
  .fixed-common {
    width: calc(100% + 24px);
    padding: 0px 24px;
    box-sizing: border-box;
    height: 68px;
    line-height: 68px;
    position: absolute;
    bottom: 0;
    left: -24px;
    display: flex;
    justify-content: center;
    box-shadow: 0 -5px 5px rgba(46, 90, 153, 0.06);
    overflow: hidden;
    overflow-x: auto;
  }
}
</style>
